import { CommunicationBridge } from '@sequelae/lore-mfe-kit';

let cachedRefUserId: number | undefined;

interface TokenClaims {
  ref_user_id?: number | string;
  [key: string]: unknown;
}

function decodeJwtPayload(token: string): TokenClaims | null {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
}

export function getRefUserId(): number | null {
  if (typeof cachedRefUserId === 'number') {
    return cachedRefUserId;
  }

  const token = CommunicationBridge.getAccessToken();
  if (!token) return null;

  const claims = decodeJwtPayload(token);
  const value = claims?.ref_user_id;
  const numericRefUserId =
    typeof value === 'number' ? value : typeof value === 'string' ? Number(value) : NaN;

  if (Number.isFinite(numericRefUserId)) {
    cachedRefUserId = numericRefUserId as number;
    return cachedRefUserId;
  }

  return null;
}

export function resetRefUserIdCache(): void {
  cachedRefUserId = undefined;
}
